import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import { onMounted, reactive } from 'vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import ConflictCheck from '../ConflictCheck.vue';
import ConflictCheckPage from './ConflictCheckPage.vue';
import { useConflictCheckFlag } from './composables/useConflictCheckFlag';

// leanLawApi and alerts are injected onto every component by the bridge's global
// mixin; they are declared here so they can be forwarded to the legacy page, which
// still takes them as props.

export default /*@__PURE__*/_defineComponent({
  __name: 'ConflictCheckRoute',
  props: {
    leanLawApi: {},
    alerts: {},
    state: {},
    stateParams: {},
    rootScope: {},
    tracking: {}
  },
  setup(__props: any) {



const meStore = useMeStore();
const { isEnabled } = useConflictCheckFlag();

const uiState = reactive({ resolving: true });

onMounted(async () => {
  try {
    await meStore.getMe();
  } catch {
    // Swallowed deliberately. getMe already reports its own failure, and the only
    // decision here is which page to render — a failed /me leaves the flag false,
    // which lands on the page that works today. Rethrowing would surface as an
    // unhandled rejection and still show that page.
  } finally {
    uiState.resolving = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!

  return (uiState.resolving)
    ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
        key: 0,
        class: "pa-6",
        type: "heading, paragraph, card"
      }))
    : (_unref(isEnabled))
      ? (_openBlock(), _createBlock(ConflictCheckPage, {
          key: 1,
          state: __props.state,
          "state-params": __props.stateParams,
          "root-scope": __props.rootScope,
          tracking: __props.tracking,
          "data-cy": "conflict-check-v2"
        }, null, 8, ["state", "state-params", "root-scope", "tracking"]))
      : (_openBlock(), _createBlock(ConflictCheck, {
          key: 2,
          "lean-law-api": __props.leanLawApi,
          alerts: __props.alerts,
          state: __props.state,
          "state-params": __props.stateParams,
          "root-scope": __props.rootScope,
          "data-cy": "conflict-check-v1"
        }, null, 8, ["lean-law-api", "alerts", "state", "state-params", "root-scope"]))
}
}

})